var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow-y":"hidden"},attrs:{"id":"app"}},[_c('router-view',{attrs:{"ifsp":_vm.device == 'sp' || _vm.device == 'tab'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }